// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { isWeb } from '../utils/platform';

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyAfyLy9DsDPfVlsIg7wYwaYGf3TeSdHxMY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Determine emulator host based on platform
const shouldUseAuthEmulator =
  process.env.REACT_APP_USE_AUTH_EMULATOR === 'true' ||
  process.env.NODE_ENV === 'development';

const getEmulatorHost = () =>
  process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST || 'http://localhost:9099';

// Connect to Firebase Auth emulator in development
if (shouldUseAuthEmulator && !auth.emulatorConfig) {
  try {
    const emulatorHost = getEmulatorHost();
    connectAuthEmulator(auth, emulatorHost);
    console.log(`🔧 Connected to Firebase Auth emulator at ${emulatorHost}`);
  } catch (error) {
    console.log('ℹ️ Firebase Auth emulator not available, using production');
  }
}

// Initialize Analytics (optional - can be disabled in development)
// Analytics may not be available in React Native (use Firebase Analytics SDK instead)
let analytics = null;
if (isWeb()) {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Analytics not available:', error);
  }
}

export { analytics };

export default app;
